import { UrlMappingsKeys } from '@wix/url-mapper-utils';
import { encodeURIComponentIfNeeded } from '../../../common/services/uri';
import { WixCodeApi } from '../../../common/types';

export const customRouteHandler = async (wixCodeApi: WixCodeApi) => {
  const path = `/${wixCodeApi.location.path
    .map(encodeURIComponentIfNeeded)
    .join('/')}`;
  const { key, segments } =
    (await wixCodeApi?.site?.getCustomizedUrlSegments?.(path)) || {};

  if (!key) {
    return null;
  }

  const slug = encodeURIComponentIfNeeded(segments?.slug);
  const instance = encodeURIComponentIfNeeded(segments?.instance);

  return (
    {
      [UrlMappingsKeys.BLOG_POST]: `/${slug}`,
      [UrlMappingsKeys.BLOG_POST_EDIT]: `/${slug}/edit`,
      [UrlMappingsKeys.BLOG_POST_PREVIEW]: `/${slug}/preview/${instance}`,
    }[key] || null
  );
};
